import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";
import Modal from "../global/modal";
import ModalClose from "../global/modalClose";
import FuzzbugCircle from "../../../assets/img/fuzzbugCircle.svg";
import { isLoggedInSelector, modalToggle } from "../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { gtmJoinClick } from "../../utilities/gtm";
import { mpModalClicked, mpSubCTASelect } from "../../utilities/mixpanel";
import { getFreeGamesHash, getSearchParamString } from "../../config";

export default function PublicModal({ doShow, close }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const dispatch = useDispatch();

  const headerString = getString("unlock.title.0");
  const primaryCTAString = getString("join.2");
  const secondaryCTAString = getString("unlock.cta.0");

  const loginLinkId = "game-public-modal-login";

  const modalEventData = {
    modalType: "unlock-modal",
    triggerType: "button click",
    header: headerString,
    primaryCta: primaryCTAString,
    secondaryCta: secondaryCTAString,
    tertiaryCta: getString("subscribe.desktopSignup.login.1"),
    isDismissible: true,
    pathname: location.pathname,
  };

  const handleLoginRef = useCallback((node) => {
    if (node) {
      document.getElementById(loginLinkId).addEventListener(
        "click",
        () => {
          mpModalClicked({
            ...modalEventData,
            interaction: "tertiary cta",
          });
          close();
          dispatch(modalToggle());
        },
        { once: true },
      );
    }
  }, []);

  return (
    <Modal doShow={doShow} closeOnEscape={close} className="unlock-modal">
      <ModalClose close={close} />

      <div className="modal-content-header">{headerString}</div>

      <p className="unlock-modal-message">{getString("unlock.message.0")}</p>

      <img className="unlock-modal-art" width="370" height="367.95" src={FuzzbugCircle} alt={headerString} />

      <button
        type="button"
        className="button-flat-color pt-green"
        onClick={() => {
          let navPath = { pathname: routeCodes.MANAGE, hash: getSearchParamString("subscription") };
          if (!isLoggedIn) {
            gtmJoinClick(location.pathname, "unlock-modal-link");
            mpSubCTASelect("general", "unlock modal", primaryCTAString, location.pathname);
            navPath = routeCodes.SUBSCRIBE;
          }

          mpModalClicked({
            ...modalEventData,
            interaction: "primary cta",
          });

          navigate(navPath);
          close();
        }}
      >
        {primaryCTAString}
      </button>

      {!isLoggedIn && (
        <p ref={handleLoginRef}>
          {getString("subscribe.desktopSignup.login.0", { replace: [loginLinkId, loginLinkId], html: true })}
        </p>
      )}

      <div className="modal-content-footer">
        <button
          type="button"
          className="button-flat-color pt-orange"
          onClick={() => {
            mpModalClicked({
              ...modalEventData,
              interaction: "secondary cta",
            });
            navigate({
              pathname: routeCodes.HOME,
              hash: getFreeGamesHash(),
            });
          }}
        >
          {secondaryCTAString}
        </button>
      </div>
    </Modal>
  );
}
